/** * [A.Block@2020-02-02] currently not in use, there is simple
MastheadSupportIcon instead * keeping for possible future requirement changes */

<template>
  <div class="wt2-sg wt2-masthead-menu">
    <wt-dropdown-view type="right" :disabled="disabled">
      <template slot="label">
        <i class="wticon wticon-hamburger3 -rotate90" />
      </template>
      <template slot="view">
        <ul class="-menu-options">
          <!--// NOTE: in unified dashboard - move to channel config (support-link-url and support-link-title)-->
          <li v-if="shouldShow(true)">
            <span @click="$_openKalturaSupport()">
              <i class="wticon wticon-help-alt wt2-color-primary" />
              <span class="wt-menu-text wt2-color-primary"
                >Knowledge Center</span
              >
            </span>
          </li>

          <!--//************************************ -->
          <li v-if="shouldShow(show.devLinks)" class="-divider" />
          <li
            v-if="shouldShow(show.devLinks)"
            @click="justDoIt"
            data-trigger="app.remoteStash.clear"
          >
            <span class="wt-menu-text">Clear Remote Stash</span>
          </li>

          <template v-if="shouldShow(show.importExport)">
            <li
              v-if="show.story"
              @click="justDoIt"
              data-trigger="app.story.export"
            >
              <span class="wt-menu-text">Export</span>
            </li>
            <li v-else @click="justDoIt" data-trigger="app.story.import">
              <span class="wt-menu-text">Import</span>
            </li>
          </template>

          <li v-if="shouldShow(show.devLinks)">
            <span @click="justDoIt" data-trigger="app.logout">
              <i class="wticon wticon-menu-logout" />
              <span class="wt-menu-text">{{
                'masthead.logout' | culture
              }}</span>
            </span>
          </li>

          <li v-if="showExpandCollapse" class="-divider" />
          <li class="-expend-collapse" v-if="showExpandCollapse">
            <span @click="toggle">
              <i
                class="wticon"
                :class="isExpend ? 'wticon-Expand8' : 'wticon-collapse8'"
              />
            </span>
          </li>
        </ul>
      </template>
    </wt-dropdown-view>
  </div>
</template>

<script>
import Vue from 'vue';
import MastheadMenuCore from './MastheadMenuCore';

export default Vue.extend({ ...MastheadMenuCore });
</script>
